// extracted by mini-css-extract-plugin
export var layoutContainer = "_da-0";
export var layoutContainerNoRounding = "_da-6";
export var layoutContainerOpen = "_da-5";
export var layoutContainerResizing = "_da-1";
export var mainContent = "_da-2";
export var resizeDivider = "_da-3";
export var slidePanel = "_da-4";